import { Injector } from '@angular/core';

export let APP_INJECTOR: Injector = Injector.create({ providers: [] });

export function setInjector(injector: Injector) {
  APP_INJECTOR = injector;
}
